export const isHTMLTemplate = (value: any): value is HTMLTemplateElement => value instanceof HTMLTemplateElement;
